module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAANFJREFUSEvtVMENwjAMvJsEugmdBJiEdhLoJHQT2MTopCBBSROnUtQ+sBQpiq4+39kuUTlYOT/+BFmHkxaZ2QHAJZNlIHmbw8wSmNkewAPAM5xYDmEULUnhfiJFcAcgBc3cx59FkGzcBGYmW7pM9e98UqHTkeynJFEFZnYCcMx28BsQ7cU6exAU7CS59F5iETR+gcB9dxEUep+EZ5tMslWGydL1JMfwrnFWjEun6Kw9iBGEPbgGgu1NUekeLLbI2/MNWeQt2YNb51fhqcyLqa7gBTvKcRlQWxesAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/img/soil.png
// module id = Ka++
// module chunks = 1